<template>
  <div id="app"> 
  	<!--<transition name="slide-left">-->
  		<router-view class="child-view"></router-view>
		<!--</transition>-->
    <!--
    <div v-show="musicPlayerIsShow" id="musicPlayer" v-bind:style="{ top: musicPlayerTop , left: musicPlayerLeft , right: musicPlayerRight   }">
      <div id="musicPlayerBtn" class="on" @click="controlMusic()" >
        <audio src="static/img/act/7/video/bg.mp3" autoplay="autoplay" id="audio" preload="preload" loop="loop"></audio>	 
      </div>
    </div>
    -->
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
    return { 
    }
  },
  mounted() {
    /*
    console.log("app",'mounted')    
    //监听音频组件播放状态
    let vm = this
    var audio = document.getElementById("audio");
      audio.addEventListener("playing", function(){		//播放状态Doing
        console.log("app","playing");
        document.getElementById("musicPlayer").style.visibility = 'visible'        
      });
      audio.addEventListener("pause", function(){ //暂停状态Doing
         console.log("pause")
      }); 
    document.addEventListener('touchstart', function () {  
      console.log("app.firstMusicPlay",vm.firstMusicPlay);
      if( vm.firstMusicPlay ) {
        vm.playMusic();   
      }
      vm.firstMusicPlay = false
    });
    */
  },
  created() {
  	console.log("app",'created')
  },
  methods: {
  }
}
</script>

<style scoped>
</style>
<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  color: #2c3e50;
}
/* 音频控制 */
#musicPlayer{  
  position:fixed;
  top: -92px;
  right: 10px;
  z-index: 99;
  visibility:hidden;
}

#musicPlayer #musicPlayerBtn{
  width: 30px;
  height: 30px;
  margin:100px auto;
  background-size: 100% 100%;
}

#musicPlayer .on{
  background: url(../static/img/act/7/music_on.png) no-repeat 0 0;-webkit-animation: rotating 1.2s linear infinite;animation: rotating 1.2s linear infinite;}
#musicPlayer .off{
  
  background: url(../static/img/act/7/music_off.png) no-repeat 0 0;}
@-webkit-keyframes rotating {
	from{
		-webkit-transform: rotate(0deg);
		-moz-transform: rotate(0deg);
		-ms-transform: rotate(0deg);
		-o-transform: rotate(0deg);
    	transform: rotate(0deg);
	}
	to{
		-webkit-transform: rotate(360deg);
		-moz-transform: rotate(360deg);
		-ms-transform: rotate(360deg);
		-o-transform: rotate(360deg);
		transform: rotate(360deg);
	}
}
@keyframes rotating {
    from{
        -webkit-transform: rotate(0deg);
		-moz-transform: rotate(0deg);
		-ms-transform: rotate(0deg);
		-o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to{
        -webkit-transform: rotate(360deg);
		-moz-transform: rotate(360deg);
		-ms-transform: rotate(360deg);
		-o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}

/* 音频控制 end */












.comment-close{
    position: absolute;
    bottom: 0;
    right: 0;
    font-size: 28px;
    padding: 15px;
 }


.child-view {  
  position: absolute;  
  left: 0;  
  top: 0;  
  width: 100%;  
  height: 100%;  
  transition: all .5s cubic-bezier(.55,0,.1,1);  
}  
.slide-left-enter, .slide-right-leave-active {  
  opacity: 0;  
  -webkit-transform: translate(0px, 0);  /*30*/
  transform: translate(0px, 0);  
}  
.slide-left-leave-active, .slide-right-enter {  
  opacity: 0;  
  -webkit-transform: translate(-0px, 0); /*-30*/ 
  transform: translate(-0px, 0);  
}
</style>


// WEBPACK FOOTER //
// src/App.vue